import { store } from "../store";
export const getColors = () => {
    var _a, _b, _c;
    const vendorConfig = store.getState().vendor.vendorDetails;
    return {
        Primary: (_a = vendorConfig.PrimaryThemeColor) !== null && _a !== void 0 ? _a : "#000",
        Secondary: (_b = vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.SecondaryThemeColor) !== null && _b !== void 0 ? _b : "#fff",
        quote: (_c = vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.SecondaryThemeColor) !== null && _c !== void 0 ? _c : '#8D868B',
        white: '#fff',
        black: '#000',
        bgText: '#666',
    };
};
